"use client";

import dynamic from "next/dynamic";

const Regulasi = dynamic(() => import("@/app/Components/Pages/Regulasi"), {
    ssr: false
});

export default function RegulasiWrapper() {
  return <Regulasi />;
}
